import { gql } from '@apollo/client/core';
import { getSharedApolloClient } from '@/lib/apollo_setup';

const GEOCODE_QUERY = gql`
  query GeocodeQuery($input: GeocodeInput!) {
    geocoding {
      geocode(input: $input) {
        x
        y
      }
    }
  }
`;

interface Coordinates {
  x: number;
  y: number;
}

interface GeocodeParams {
  zipCode: string | null | undefined;
}

interface GeocodeQueryResponse {
  geocoding?: {
    geocode?: {
      x: string;
      y: string;
    } | null;
  } | null;
}

function isValidZipcode(zipcode: string | null | undefined): boolean {
  return !!zipcode && /^\d{5}(-\d{4})?$/.test(zipcode);
}

async function geocode({ zipCode }: GeocodeParams): Promise<Coordinates | null> {
  if (!zipCode || !isValidZipcode(zipCode)) {
    return null;
  }

  const { data, errors } = await getSharedApolloClient().query<GeocodeQueryResponse>({
    query: GEOCODE_QUERY,
    variables: { input: { zipCode } },
    errorPolicy: 'all',
  });
  if (errors?.length) {
    return null;
  }
  const geocodeData = data?.geocoding?.geocode;
  if (!geocodeData) return null;

  return {
    x: Number(geocodeData.x),
    y: Number(geocodeData.y),
  };
}

export { geocode }; // primary
export { isValidZipcode }; // secondary
export type { Coordinates, GeocodeParams }; // types
